import { useState } from 'react';
import api from '../../../core/api/api';

const useCalendario = () => {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchEventos = async (start, end) => {
    setLoading(true);
    try {
      const response = await api.get('/Turnos/Calendario', {
        params: {
          fechaDesde: start.toISOString(),
          fechaHasta: end.toISOString()
        }
      });
      
      const eventosFormateados = response.data.map(e => ({
        id: e.id,
        title: e.titulo,
        start: e.inicio,
        end: e.fin,
        backgroundColor: e.color,
        textColor: 'black',
        extendedProps: {
          type: e.tipo || (e.color === 'Orange' ? 'Nota' : 'Turno'),
          estadoTurno: e.estadoTurno,
          idHorarioMedico: e.idHorarioMedico
        }
      }));
      
      setEventos(eventosFormateados);
    } catch (error) {
      console.error('Error al cargar eventos:', error);
    } finally {
      setLoading(false);
    }
  };

  const crearNota = async (start, end, note) => {
    try {
      await api.post('/Notas', {
        fechaIniTurno: start.toISOString(),
        fechaFinTurno: end.toISOString(),
        observacion: note
      });
      fetchEventos(start, end);
    } catch (error) {
      console.error('Error al crear nota:', error);
    }
  };

  const eliminarNota = async (idNota) => {
    try {
      await api.delete(`/Notas/${idNota}`);
      setEventos(prev => prev.filter(e => e.id !== idNota));
    } catch (error) {
      console.error('Error al eliminar nota:', error);
    }
  };

  return { eventos, loading, fetchEventos, crearNota, eliminarNota };
};

export default useCalendario;
